<template>
  <popup
    :opened="isShow"
    @close="close"
  >
    <!-- BEGIN Popup contents -->
    <div>
      <div class="my-5 xl:my-15">
        <h3 class="mb-5 md:mb-10 2xl:mb-15">
          Session expirée
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Votre session a expirée. Vous avez été inactif pendant une trop longue période.
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Votre session s'est fermée automatiquement.
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Vous pouvez vous reconnecter afin de reprendre votre travail.
          </p>
        </div>

        <div class="flex justify-center bg-pink">
          <action-button
            class="mr-4"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            type-shadow="shadow-pink"
            libelle="FERMER"
            @clickAction="close"
          />
        </div>
      </div>
    </div>
    <!-- END Popup contents -->
  </popup>
</template>

<script>
import Popup from './../Popup.vue';
import ActionButton from './../ActionButton.vue';
import Icon from './../Icon.vue';

export default {
  props:{
    isShow:{
      type:Boolean,
      required:false,
      default:false,
    },
  },

  components:{
    Popup,
    ActionButton,
    Icon,
  },

  methods:{
    close(){
      this.$emit('close');
    }
  },
};
</script>
